import * as React from 'react';
const SvgThreeDots = (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" height="1em" viewBox="0 0 14 3" width="1em" {...props}>
        <path
            clipRule="evenodd"
            d="M0 1.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm5.5 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm7-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
export default SvgThreeDots;
